const translations = {
    'log.farmersNoTools': 'Rolnicy bez narzędzi: %d',
    'log.huntersNoTools': 'Myśliwi bez narzędzi: %d',
    'log.none': 'Brak ostrzeżeń.',
    'log.section': 'Ostrzeżenia',
};

export default translations;
